import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Subscription } from 'rxjs';
import { WlEventsToolbarEvent } from './toolbar-events-broadcast-event.model';

/**
 * service to broadcast events happening to or from the events toolbar
 */
@Injectable()
export class WlEventsToolbarBroadcastService extends Subject<WlEventsToolbarEvent> {
  /**
   * construct
   */
  public constructor() {
    super();
  }

  /**
   * broadcast an event
   * @param event
   */
  public broadcast(event: WlEventsToolbarEvent): void {
    this.next(event);
  }
}
